import { STORE_ID, TYPES } from "./types"

const INITIAL_STATE = {
    item: {
        descricao: "",
        id: ""
    },
    copy: {},
    invalid: {
        descricao: false,
    },
    items: [],
    activeTab: "Search",
    seeRegister: false,
    activePersona: false,
    permitions: {
        criar: false,
        deletar: false,
    }
}

export default function perfilCliente(state = INITIAL_STATE, action) {
    switch (action.storeId) {
        case STORE_ID:
            switch (action.type) {
                case TYPES.SET_PERMITIONS:
                    return { ...state, permitions: action.value }
                case TYPES.PERFILS:
                    return { ...state, items: action.value }
                case TYPES.PERFIL:
                    return { ...state, item: action.value }
                case TYPES.INVALID_PERFIL:
                    return { ...state, invalid: { ...state.invalid, [action.field]: true } }
                case TYPES.CLEAN_INVALID_PERFIL:
                    return { ...state, invalid: { ...state.invalid, [action.field]: false } }
                case TYPES.PERFIL_COPY:
                    return { ...state, copy: action.value }
                case TYPES.CLEAN_REGISTER:
                    return { ...state, item: INITIAL_STATE.item, invalid: INITIAL_STATE.invalid }
                case TYPES.SET_ACTIVE_TAB:
                    return { ...state, activeTab: action.value }
                case TYPES.SET_SEE:
                    return { ...state, seeRegister: action.value }
                case TYPES.SET_PERSONA:
                    return { ...state, activePersona: action.value }
                default:
                    return { ...state }
            }
        default:
            return { ...state }
    }
}